module.exports = __webpack_public_path__ + "static/img/no-video.a9269a9e.svg";